interface LanguageText {
    product_name: string;
    tab_product: string;
    tab_bundles?: string;
    tab_support: string;
    tab_specs: string;
    tab_media: string;
    btn_buy: string;
    tab_compatibility: string;
}

type SupportedLocale = 'us' | 'ca' | 'de' | 'uk' | 'eu' | 'fr' | 'it' | 'es' | 'nl';

type LangTextType = Record<SupportedLocale, LanguageText>;

export const LangText: LangTextType = {
    us: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
        tab_compatibility: 'Compatibility'
    },
    ca: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Product',
        tab_bundles: 'Bundles',
        tab_support: 'Support',
        tab_specs: 'Specs',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
        tab_compatibility: 'Compatibility'
    },
    de: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Produkt',
        tab_specs: 'Technische Daten',
        tab_support: 'Support',
        tab_compatibility: 'Kompatibilität',
        tab_media: 'Media',
        btn_buy: 'Jetzt shoppen',
    },
    eu: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Product',
        tab_specs: 'Specs',
        tab_support: 'Support',
        tab_compatibility: 'Compatibility',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    uk: {
        product_name: 'EcoFlow DELTA 3 Classic (1024Wh)',
        tab_product: 'Product',
        tab_specs: 'Specs',
        tab_support: 'Support',
        tab_compatibility: 'Compatibility',
        tab_media: 'Media',
        btn_buy: 'Shop Now',
    },
    fr: {
        product_name: 'EcoFlow DELTA 3 Classic (1 024 Wh)',
        tab_product: 'Produit',
        tab_specs: 'Spécifications',
        tab_support: 'Support',
        tab_compatibility: 'Compatibilité',
        tab_media: 'Media',
        btn_buy: 'Acheter',
    },
    it: {
        product_name: 'EcoFlow DELTA 3 Classic (1.024 Wh)',
        tab_product: 'Prodotto',
        tab_specs: 'Specifiche',
        tab_support: 'Assistenza',
        tab_compatibility: 'Compatibilità',
        tab_media: 'Media',
        btn_buy: 'Acquista ora',
    },
    es: {
        product_name: 'EcoFlow DELTA 3 Classic (1024 Wh)',
        tab_product: 'Producto',
        tab_specs: 'Especificaciones',
        tab_support: 'Asistencia',
        tab_compatibility: 'Compatibilidad',
        tab_media: 'Media',
        btn_buy: 'Comprar ahora',
    },
    nl: {
        product_name: 'EcoFlow DELTA 3 Classic (1024 Wh)',
        tab_product: 'Product',
        tab_specs: 'Specificaties',
        tab_support: 'Ondersteuning',
        tab_compatibility: 'Compatibiliteit',
        tab_media: 'Media',
        btn_buy: 'Nu winkelen',
    },
};
